import type { ApiError } from "@entrilia/shared/api/types";
import type {
  ProtectionProbe,
  UserPermissionsResponse,
  ViewOnlyFileProtection,
  ViewOnlyFileProtectionWire,
} from "../../store/state/user/types";

export const mapViewOnlyFileProtection = (
  wire: ViewOnlyFileProtectionWire | undefined
): ViewOnlyFileProtection | undefined =>
  wire ? { parameterName: wire.n, keys: wire.k.map((key) => ({ version: key.v, key: key.d })) } : undefined;

// Fail-closed hinge: an absent payload means "protection is off" ONLY when the server actually answered.
export const toProtectionProbe = (
  response: UserPermissionsResponse | undefined,
  error: ApiError | undefined
): ProtectionProbe =>
  error || !response ? { answered: false } : { answered: true, protection: mapViewOnlyFileProtection(response.fp) };
